import { useAppEventBusContext } from '@/context/eventBusContext';
import { useWebSocket } from '@/context/websocketContext';
import { SubscribeEvent } from '@/interface/event';
import { useCallback, useEffect } from 'react';

export default () => {
  const { data: wsData, isConnected, sendMessage } = useWebSocket();
  const { publish } = useAppEventBusContext();

  const subscribeToWebSocket = useCallback(() => {
    if (isConnected) {
      sendMessage('subscribePumpNewborn');
      return () => sendMessage('unsubscribePumpNewborn');
    }
  }, [isConnected]);

  const handleWebSocketUpdate = useCallback(() => {
    if (!wsData?.data) return;

    if (wsData.event === 'pumpNewborn') {
      publish(SubscribeEvent.Update_Pump_Create, wsData.data);
    }
  }, [isConnected, wsData]);

  useEffect(subscribeToWebSocket, [isConnected]);
  useEffect(handleWebSocketUpdate, [isConnected, wsData]);
};
